import React, { useEffect, useState } from "react";
import { getChargers } from "../../services/chargerService";
import Loader from "../../components/Loader";

function Chargers() {
  const [chargers, setChargers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getChargers()
      .then(data => setChargers(data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loader />;

  return (
    <div>
      <h2>Chargers</h2>
      <ul>
        {chargers.map(c => (
          <li key={c.id}>{c.name} - {c.status}</li>
        ))}
      </ul>
    </div>
  );
}

export default Chargers;
